const base_Url = "https://lb-api.ludobro.com/";
// const base_Url = "http://localhost:2101/";

export default base_Url;
